import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../config/msalConfig';
import { authenticationService } from '../../services';

const MicrosoftSSO = () => {
    const { instance } = useMsal();

    const decodeJWT = (token) => {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
    };

    const handleLogin = async () => {
        try {
            const response = await instance.loginPopup(loginRequest);

            if (response && response.idToken) {
                const decoded = decodeJWT(response.idToken);

                if (decoded) {
                    // Validate tenant - must be nectr.com.au
                    const email = decoded.email || decoded.preferred_username || '';
                    if (!email.toLowerCase().endsWith('@nectr.com.au')) {
                        console.error('Unauthorized domain. Only nectr.com.au accounts are allowed.');
                        alert('Access denied. Only nectr.com.au accounts are allowed.');
                        return;
                    }

                    // Create profile object matching Google SSO format
                    const profileObj = {
                        email: email,
                        imageUrl: '', // Microsoft Graph API would be needed for profile pictures
                        name: decoded.name || email.split('@')[0],
                    };

                    const tokenObj = {
                        id_token: response.idToken,
                        expires_at: decoded.exp * 1000, // Convert to milliseconds
                    };

                    authenticationService.login(profileObj, tokenObj);
                }
            }
        } catch (error) {
            console.error('Microsoft login failed:', error);
            if (error.errorCode !== 'user_cancelled') {
                authenticationService.logout();
            }
        }
    };

    return (
        <button
            onClick={handleLogin}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px 24px',
                fontSize: '14px',
                fontWeight: '500',
                color: '#3c4043',
                backgroundColor: '#ffffff',
                border: '1px solid #dadce0',
                borderRadius: '4px',
                cursor: 'pointer',
                width: '100%',
                maxWidth: '240px',
                marginTop: '12px',
                fontFamily: '"Google Sans", Roboto, Arial, sans-serif',
                transition: 'background-color 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
                e.target.style.boxShadow = '0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)';
            }}
            onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#ffffff';
                e.target.style.boxShadow = 'none';
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                style={{ marginRight: '12px' }}
            >
                <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
            Sign in with Microsoft
        </button>
    );
};

export default MicrosoftSSO;
